<script lang="ts">
	import { TalkPage } from '#lib/websites/talks/pages/TalkPage/index.js';
</script>

<TalkPage />
